import { Route } from '@common/components/utility/BreadCrumbRoute';
import { AppStore } from '@common/stores';
import { createRoutesFromChildren } from '@common/utils/routerUtil';
import { ZipCodeOutlet } from '@customer/components/outlets';
import { AppointmentsContainer, IntakeCustomerDetail, IntakeView, ValidationView, ValidationViewStore } from '@customer/views';
import { ConsentContainer } from '@customer/views/consent/ConsentContainer';
import { IntakePetContainer } from '@customer/views/intake/IntakePetContainer';
import { RebookContainer } from '@customer/views/rebook';
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { BreadcrumbsRoute } from 'use-react-router-breadcrumbs';


export const Throw404 = () => {
    throw new DOMException('The resource you are requesting does not exist.', DOMException.NOT_FOUND_ERR.toString());
}

export const buildAppRoute = (appStore: AppStore): BreadcrumbsRoute[] => {
    const validationViewStore = new ValidationViewStore();

    return createRoutesFromChildren(
        <Route path="/" element={<Outlet />} >
            <Route path="validation" element={<ValidationView store={validationViewStore} />} />
            <Route path="intake/:intakepublicid" element={<IntakeView />} /> 
            <Route element={<ZipCodeOutlet />}>
                <Route path="customerprofile/:intakepublicid" element={<IntakeCustomerDetail />} />
            </Route>                      
            <Route path="petprofile/:intakepublicid/:intakepetid" element={<IntakePetContainer />} />
            <Route path="appointment/:verificationpublicid" element={<AppointmentsContainer />} />
            <Route path="consent/:visitPublicId/:consentTypePublicId" element={<ConsentContainer />} />
            <Route path="rebook/:clinicId/:reservationPublicId" element={<RebookContainer />} />
            <Route path="" element={<Navigate to={`validation`} />} />
            <Route path="*" element={<Navigate to={`validation`} />} />
        </Route>
    );
}
